<template lang="html">
  <div class="domain-help">
    <Guide
      :content="content"
      width="x-small"
      buttonText="Find DNS Settings"
      contentHeading="Mange your domain name"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'DomainLogin',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'domain-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'domain-dns-management',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>Because you've already registered a domain name, the quickest way to get your site online is to configure the settings and point it to our server.</p>
        <p>You'll update your <strong>A Records</strong> and generate an <strong>SSL certificate</strong> in this simple process.</p>
        <p>Once you've logged into your domain host, proceed to the next step. You may find your host in the list below:</p>
        <div class="domain-host-list">
          <a target="_blank" href="https://login.ionos.co.uk/">1&1 IONOS</a>
          <a target="_blank" href="https://www.123-reg.co.uk/">123-Reg</a>
          <a target="_blank" href="https://www.bluehost.com/">Bluehost</a>
          <a target="_blank" href="https://www.crazydomains.co.uk/">Crazy Domains</a>
          <a target="_blank" href="https://www1.dotster.com/secure/login.bml">Dotster</a>
          <a target="_blank" href="https://www.dreamhost.com/">DreamHost</a>
          <a target="_blank" href="https://www.dynadot.com/">Dynadot</a>
          <a target="_blank" href="https://easydns.com">EasyDNS</a>
          <a target="_blank" href="https://enom.com">Enom</a>
          <a target="_blank" href="https://godaddy.com">GoDaddy</a>
          <a target="_blank" href="https://domains.google.com/registrar">Google Domains</a>
          <a target="_blank" href="https://hostgator.com">HostGator</a>
          <a target="_blank" href="https://hover.com">Hover</a>
          <a target="_blank" href="https://iwantmyname.com/#login">IWantMyName</a>
          <a target="_blank" href="https://www.name.com/account/login">Name.com</a>
          <a target="_blank" href="https://namecheap.com/myaccount/login/">Namecheap</a>
          <a target="_blank" href="https://www.networksolutions.com/">Network Solutions</a>
          <a target="_blank" href="https://register.com">Register.com</a>
          <a target="_blank" href="https://strato.com">Strato</a>
          <a target="_blank" href="https://wordpress.com/log-in">WordPress</a>
          <a target="_blank" href="https://login.yahoosmallbusiness.com/">Yahoo</a>
        </div>
        `
    }
  }
}
</script>

<style lang="sass">
  .domain-host-list
    border: 1px solid rgba(0, 0, 0, 0.1)
    padding: 10px
    border-radius: 5px
    max-height: 260px
    width: 100%
    overflow: auto
    margin-bottom: 30px

    a
      display: block
      font-size: 14px
      margin-bottom: 5px

      &:last-child
        margin: 0
</style>
